const initialState = {
  user_type: localStorage && JSON.parse(localStorage.getItem("user_type")),
  user: JSON.parse(localStorage.getItem("user")),
  basket: JSON.parse(localStorage.getItem("basket")) || {},
  popUp: JSON.parse(localStorage.getItem("popUp")) || false,
  item_id: false,
  favorites: JSON.parse(localStorage.getItem("favorites")) || [],
  classData: JSON.parse(localStorage.getItem("classData")) || {},

  sort: [
    {
      name: "بیشترین قیمت",
      id: "maxPrice",
    },
    {
      name: "کمترین قیمت",
      id: "minPrice",
    },
    {
      name: "پرفروش ترین",
      id: "mostSell",
    },
    {
      name: "امتیاز",
      id: "mostScore",
    },
  ],
};

const reducers = (state = initialState, action) => {
  switch (action.type) {
    case "SET":
      if (action.local_storage) {
        let { key, value } = action.local_storage;
        localStorage.setItem(key, JSON.stringify(value));
      }
      if (action.noaction) {
        return state;
      }
      return { ...state, ...action.payload };
    case "REMOVE":
      if (action.local_storage) {
        let { key } = action.local_storage;
        localStorage.removeItem(key);
      }
      if (action.noaction) {
        return state;
      }
      return delete action.payload, state;
    case "CLEAR":
      localStorage.clear();
      return {};
    default:
      return state;
  }
};
export default reducers;
